// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__gchBS","content":"PageLayout_content__SoDXP","padding":"PageLayout_padding__kzIHJ"};